import { render, staticRenderFns } from "./authEmail.vue?vue&type=template&id=84dcb300&scoped=true&"
import script from "./authEmail.vue?vue&type=script&lang=js&"
export * from "./authEmail.vue?vue&type=script&lang=js&"
import style0 from "./authEmail.vue?vue&type=style&index=0&id=84dcb300&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dcb300",
  null
  
)

export default component.exports